import { render, staticRenderFns } from "./executive.vue?vue&type=template&id=0871294e&scoped=true"
import script from "./executive.vue?vue&type=script&lang=js"
export * from "./executive.vue?vue&type=script&lang=js"
import style0 from "./executive.vue?vue&type=style&index=0&id=0871294e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871294e",
  null
  
)

export default component.exports